import styled from "styled-components";
import { beforeCss } from "../../atom";

export const AnimationNormalRechargeWrapper = styled.div``;

export const MemberCard = styled.div<{
  isActive: boolean;
  heightCard: boolean;
  isDiamond: boolean;
}>`
  width: 224px;
  height: ${(p) => (p.heightCard ? "167px" : "134px")};
  box-shadow: inset 0 0 0 1px rgba(73, 83, 89, 1);
  background: ${(p) => (p.isActive ? "rgba(19, 203, 117, 0.04)" : "#292B2F")};
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  cursor: pointer;
  padding: 14px;
  ${(p) => p.isActive && beforeCss}
  .recharge-price {
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: ${(p) => (p.isDiamond ? "unset" : "7px 0 15px")};
    font-weight: 500;
    font-size: 16px;
    height: ${(p) => (p.isDiamond ? "100px" : "42px")};
    .price {
      font-size: 30px;
    }
  }
  .luck-draw-text {
    margin-top: 8px;
    width: 100%;
    height: 26px;
    border-radius: 20px;
    background-color: ${(p) => (p.isActive ? "#FFBD1526" : "#3D4045")};
    font-size: 14px;
    font-weight: 500;
    line-height: 26px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    gap: 6px;
  }
  :hover {
    background: rgba(19, 203, 117, 0.04);
    ${beforeCss};
    .luck-draw-text {
      background-color: #ffbd1526;
    }
  }
`;

export const Level = styled.div`
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  line-height: 20px;
`;

export const DisacountText = styled.div`
  font-size: 14px;
  line-height: 20px;
`;
